import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/utils/axiosInterceptor";
import type {
	CompanySettings,
	UpdateCompanySettings,
} from "@/types/companySettings";

export const useCompanySettings = () => {
	const queryClient = useQueryClient();

	const {
		data: settings,
		isLoading,
		error,
	} = useQuery({
		queryKey: ["companySettings"],
		queryFn: async () => {
			const response = await api.get<{ status: string; data: CompanySettings }>(
				"/company-settings",
			);
			return response.data.data;
		},
	});

	const updateSettingsMutation = useMutation({
		mutationFn: (data: UpdateCompanySettings) =>
			api.put<{ status: string; data: CompanySettings }>(
				"/company-settings",
				data,
			),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["companySettings"] });
		},
	});

	return {
		settings,
		isLoading,
		error,
		updateSettings: updateSettingsMutation.mutateAsync,
		isUpdating: updateSettingsMutation.isPending,
	};
};
